import React from 'react';
import {Modal} from 'react-bootstrap';
import {personFullName} from '../../../../services/Api/index';


const DeleteAnnuityPaymentModal = (props)=>{

    const { annuityPayment, onHide, onConfirm, type }= props;

    const person = annuityPayment.membership? annuityPayment.membership.person : props.person;

    return (
        <Modal
            show={true}
            onHide={onHide}>

            <Modal.Header closeButton>
                <Modal.Title>Eliminar pago de anualidad de {type==='ihs'?'IHS':'membresía'}</Modal.Title>
            </Modal.Header>

            <Modal.Body >
                <p>¿Estás seguro que deseas eliminar al pago de {type==='ihs'?'IHS':'membresía'} del año&nbsp;
                    <strong>{annuityPayment.year}</strong>&nbsp;
                    correspondiente a <strong>{personFullName(person)}</strong> ?
                </p>
                <p>Esta acción no puede deshacerse.</p>
            </Modal.Body>

            <Modal.Footer>
                <button onClick={ onHide } className='btn btn-primary pull-left'>Cancelar</button>
                <button className='btn btn-danger' onClick={ ()=>onConfirm( annuityPayment ) }>Eliminar</button>
            </Modal.Footer>

        </Modal>
    );
};

export default DeleteAnnuityPaymentModal;


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/components/DeleteAnnuityPaymentModal/index.jsx